export default __webpack_public_path__ + "static/features-phone-activities-66ccd3c8e546a733d44002732bd7bd8f.png";